import axiosInstance from "../../../interceptor/intercetptor-inctence";

export const getPatientList = (formData) => {
    return axiosInstance.post(`api/lab-patient/list`, formData);
}

export const statusPatient = (id) => {
    return axiosInstance.post(`api/lab-patient/change-status/${id}`,{});
}

export const deletePatient = (id) => {
    return axiosInstance.post(`api/lab-patient/delete/${id}`,{});
}

export const addPatient = (formData) => {
    return axiosInstance.post(`api/lab-patient/add`,formData);
}

export const updatePatient = (id,formData) => {
    return axiosInstance.post(`api/lab-patient/update/${id}`,formData);
}

export const viewPatient = (id) => {
    return axiosInstance.post(`api/lab-patient/detail/${id}`,{});
}

// export const masterDepartment = () => {
//     return axiosInstance.post(`api/master/department/master-list`,{});
// }

// export const masterSample = () => {
//     return axiosInstance.post(`api/master/samle-type/master`,{});
// }

// export const masterPatient = () => {
//     return axiosInstance.post(`api/master/lab-patient-method/list `,{});
// }

// export const masterParameter = () => {
//     return axiosInstance.post(`api/parameters/master-list`,{});
// }

